import { useMap } from "react-leaflet";

function ChangeCenter({coords} : any){
    const map = useMap();
    map.setView(coords, map.getZoom());
    return null;
}

export default ChangeCenter;